import { Box } from '@mui/material';

function WifiOffIcon({ ...props }) {
  return (
    <Box
      component="svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 140 140"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1106_18192)">
        <path
          d="M122.502 64.1666L134.168 52.5C112.41 30.7417 82.4266 22.4583 54.2516 27.3583L69.3016 42.4083C88.5516 42.2917 107.86 49.525 122.502 64.1666ZM110.835 75.8333C104.535 69.5333 97.0683 65.0417 89.135 62.2417L106.752 79.8583L110.835 75.8333ZM52.5016 99.1667L70.0016 116.667L87.5016 99.1667C77.8766 89.4833 62.185 89.4833 52.5016 99.1667ZM19.8933 9.56665L11.6683 17.7917L29.46 35.5833C20.9433 39.8417 12.9516 45.4417 5.83496 52.5L17.5016 64.1666C24.6766 56.9916 32.96 51.5667 41.8266 47.95L54.8933 61.0167C45.4433 63.525 36.5766 68.4833 29.1683 75.8333L40.835 87.5C48.71 79.625 58.9766 75.6 69.36 75.4833L110.66 116.783L118.885 108.558L19.8933 9.56665Z"
          fill="#919EAB"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_18192">
          <rect width="140" height="140" fill="white" />
        </clipPath>
      </defs>
    </Box>
  );
}

export default WifiOffIcon;
